/*
 * Shared MUI `sx` fragments for the PackageHistoryModal tables.
 * Colors reference the CSS variables defined in PackageHistoryModal.css
 * (scoped to .package-history-modal), so no new hex values are introduced.
 */

// Base table: compact rows, app border color.
export const tableSx = {
  '& td, & th': {
    borderColor: 'var(--phm-border)',
    py: 0.75,
    px: 1.25,
  },
};

// Fixed header-row height — lets the second row of a two-row sticky header
// offset by an exact amount (see subHeadStickySx).
export const HEADER_ROW_H = 34;

// Column header cell. Opaque background so sticky headers cover scrolling rows.
export const headSx = {
  height: HEADER_ROW_H,
  boxSizing: 'border-box',
  fontWeight: 600,
  fontSize: '0.7rem',
  color: 'var(--phm-text-muted)',
  bgcolor: 'var(--phm-surface)',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

// Group header cell (spans multiple columns in a two-row thead).
export const groupHeadSx = {
  ...headSx,
  textAlign: 'center',
};

// Second row of a two-row sticky header: pin it below the first (group) row.
export const subHeadStickySx = {
  top: `${HEADER_ROW_H}px`,
};

// Right-aligned numeric cell with tabular figures.
export const numSx = {
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
  whiteSpace: 'nowrap',
};

// Vertical divider between column groups (Before/After, Shop/Field).
export const dividerLeftSx = {
  borderLeft: '2px solid var(--phm-border)',
};

// Body cell value color.
export const valueSx = {
  color: 'var(--phm-text-value)',
  whiteSpace: 'nowrap',
};

// Dialog uses z-index 100001 (above Bryntum). Tooltips portal to document.body
// at the theme default (~1500), so they must be raised or they sit behind the modal.
export const tooltipPopperProps = { sx: { zIndex: 100002 } };
